import {Component, Input, OnInit} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {AppSharedModule} from "@modules/app-shared.module";
import {DocumentFile} from "@ui-kit/webkit/components/image-carousel/image-carousel.model";
import {ImageGridComponent} from "@ui-kit/webkit/components/image-grid/image-grid.component";
import {LeaseDocument} from "../../leasing.model";
import {AddDocumentDialogComponent} from "../lease-documents/add-document-dialog/add-document-dialog.component";
import {LeaseDocumentsService} from "../lease-documents/lease-documents.service";

@Component({
  selector: 'app-lease-showcase',
  standalone: true,
  imports: [
    FlexModule,
    MatButtonModule,
    MatIconModule,
    AppSharedModule,
    MatProgressSpinnerModule,
    ImageGridComponent
  ],
  templateUrl: './lease-showcase.component.html'
})
export class LeaseShowcaseComponent implements OnInit {
  @Input() id!: string;
  @Input() offeringId!: string;

  leaseImageDocs: LeaseDocument[] = [];
  leaseImageFiles: DocumentFile[] = [];

  private pageSize = 10;
  private currentLoadedIndex = 0;
  isLoading = false;
  hasMoreImagesToLoad = false;

  constructor(private documentsService: LeaseDocumentsService,
              private matDialog: MatDialog,) {
  }

  ngOnInit() {
    this.loadDocuments();
  }

  loadDocuments() {
    this.documentsService.getLeaseDocuments(this.id).subscribe({
      next: value => {
        this.leaseImageDocs = value.filter(f => f.documentTypeCode == 'SHOWCASE_IMAGE')
          .sort((a, b) => new Date(a.createDate!).getTime() - new Date(b.createDate!).getTime());
        this.loadInitialImages();
      },
      error: err => console.log(err)
    })
  }

  private loadInitialImages() {
    this.currentLoadedIndex = 0;
    this.leaseImageFiles = [];
    this.loadMoreImages();
  }

  loadMoreImages() {
    if (this.isLoading) return;

    this.isLoading = true;
    const endIndex = Math.min(this.currentLoadedIndex + this.pageSize, this.leaseImageDocs.length);
    const imagesToLoad = this.leaseImageDocs.slice(this.currentLoadedIndex, endIndex);
    let loadedCount = 0;

    imagesToLoad.forEach(docObject => {
      this.documentsService.getDocumentFile(this.id, docObject.uuid!).subscribe({
        next: (value) => {
          const type = ('application/' + docObject.mimeType).toString();
          const file = new Blob([value], {type});
          const fileURL = URL.createObjectURL(file);
          this.leaseImageFiles.push({
            fileUuid: docObject.fileUuid,
            documentId: docObject.documentUuid!,
            fileUrl: fileURL,
            blob: value,
            fileType: docObject.mimeType,
            fileName: docObject.fileName
          });

          loadedCount++;
          if (loadedCount === imagesToLoad.length) {
            this.currentLoadedIndex = endIndex;
            this.hasMoreImagesToLoad = this.currentLoadedIndex < this.leaseImageDocs.length;
            this.isLoading = false;
          }
        },
        error: err => {
          console.log(err);
          loadedCount++;
          if (loadedCount === imagesToLoad.length) {
            this.isLoading = false;
          }
        }
      })
    })

    // If there are no images to load, reset loading state
    if (imagesToLoad.length === 0) {
      this.isLoading = false;
    }
  }

  addImage() {
    this.matDialog.open(AddDocumentDialogComponent, {
      panelClass: 'dialog-large',
      width: '250px',
      data: {
        leaseId: this.id,
        setType: "SHOWCASE_IMAGE"
      }
    }).afterClosed()
      .subscribe(() => {
        this.loadDocuments();
      });
  }

  removeDocumentFromLease(docId: string) {
    if (docId) {
      this.documentsService.removeLeaseDocument(docId, this.id).subscribe({
        next: () => {
          this.loadDocuments();
        },
        error: err => {
          console.log(err);
        }
      });
    }
  }

}
